window.scrollToTop = {
  init: function () {
    function doOnDocumentLoaded() {
      const toTopBtn = document.querySelector(".m-footer__totop a.m-button__top");

      if (toTopBtn) {
        toTopBtn.addEventListener("click", function (e) {
          e.preventDefault();
          
          window.scrollToTop.topFunction();
        });

        if (window.scrollY > 2000) {
          toTopBtn.closest(".m-footer__totop").classList.add("is-visible");
        } else {
          toTopBtn.closest(".m-footer__totop").classList.remove("is-visible");
        }
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", doOnDocumentLoaded);
    } else {
      doOnDocumentLoaded();
    }
  },

  // When the user clicks on the button, scroll to the top of the document
  topFunction: function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
};

window.addEventListener("load", function () {
  window.scrollToTop.init();
});

window.addEventListener(
  "scroll",
  function (event) {
    window.scrollToTop.init();
  },
  false,
);
